export default "__VITE_ASSET__BaG5azWM__"